import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { addDays } from "date-fns";

function PopularDestinations() {
  const navigate = useNavigate();

  const destinations = [
    {
      city: "Bangkok",
      airport: "Suvarnabhumi International Airport (BKK)",
      flag: "🇹🇭",
      code: "BKK",
    },
    {
      city: "Istanbul",
      airport: "Istanbul Airport (IST)",
      flag: "🇹🇷",
      code: "IST",
    },
    {
      city: "London",
      airport: "London (LON)",
      flag: "🇬🇧",
      code: "LON",
    },
    {
      city: "New York",
      airport: "New York (NYC)",
      flag: "🇺🇸",
      code: "NYC",
    },
    {
      city: "Antalya",
      airport: "Antalya Airport (AYT)",
      flag: "🇹🇷",
      code: "AYT",
    },
    {
      city: "Dubai",
      airport: "Dubai International (DXB)",
      flag: "🇦🇪",
      code: "DXB",
    },
    {
      city: "Paris",
      airport: "Paris (PAR)",
      flag: "🇫🇷",
      code: "PAR",
    },
    {
      city: "Barbados",
      airport: "Barbados Airport (BGI)",
      flag: "🇧🇧",
      code: "BGI",
    },
    {
      city: "Buenos Aires",
      airport: "Buenos Aires (BUE)",
      flag: "🇦🇷",
      code: "BUE",
    },
  ];

  const handleClick = (destination) => {
    const outbound = addDays(new Date(), 7);
    const returnDate = addDays(new Date(), 14);

    // Format dates to YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split("T")[0];

    // Create search parameters
    const params = new URLSearchParams({
      route: `LON-${destination.code}`,
      outbound: formatDate(outbound),
      return: formatDate(returnDate),
      adults: 1,
      children: 0,
      infants: 0,
      class: "Economy",
      currency: "GBP",
    });

    // Navigate directly to search results
    navigate(`/flights/search?${params.toString()}`);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold mb-4">Popular destinations</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {destinations.map((destination) => (
          <button
            key={destination.city}
            onClick={() => handleClick(destination)}
            className="bg-gray-100 rounded-3xl p-6 flex items-center justify-between hover:shadow-md transition-shadow text-left w-full"
          >
            <div className="flex flex-col">
              <span className="text-3xl">{destination.flag}</span>
              <div className="flex flex-col">
                <span className="text-lg font-medium">{destination.city}</span>
                <span className="text-sm text-gray-500">
                  {destination.airport}
                </span>
              </div>
            </div>
            <FontAwesomeIcon
              className="bg-white p-2 w-4 h-4 rounded-full"
              icon={faChevronRight}
            />
          </button>
        ))}
      </div>
    </div>
  );
}

export default PopularDestinations;
